import React, { useEffect } from 'react';
import { matchPath, useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import {
  fetchAddons,
  fetchAddonsPopular,
  fetchAddonsRecents,
  fetchAddonsTrending
} from '../../../actions/mods_factory/addonsActions';
import { queryParams } from "../../../helpers/UrlHelpers";
import modsfactoryUrls from "../../../configs/mods_factory/modsfactoryUrls";

import PageHeader from './_partials/_PageHeader';
import PageLayout from '../_partials/PageLayout';
import List from "./_partials/_List";
import Edit from "./Edit";
import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import Filter from "../../../componets/Filter";
import './style.scss';

const LIMIT = 42;
const TYPES: any = {
  1: {
    name: 'Addon'
  },
  2: {
    name: 'Skin'
  },
  3: {
    name: 'World'
  },
  4: {
    name: 'Skin Pack'
  },
  5: {
    name: 'Post'
  },
  6: {
    name: 'Structure'
  },
};
const TYPES_IDS = Object.keys(TYPES);

const Addons = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const typeId          = queryParams.getInt(searchParams,'add_type');
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const { pathname }    = useLocation();
  const orderByFilter   = !!matchPath(modsfactoryUrls.addonsPath(), pathname) ? {
    items: [
      { name: 'Date', key: 'id' },
      { name: 'Popular', key: 'popular_count' },
      { name: 'Comments', key: 'comments_count' },
      { name: 'Likes', key: 'likes_count' },
      { name: 'Downloads', key: 'downloads_count' },
    ]
  } : undefined;

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (typeId) {
      params.add_type = typeId;
    }

    switch (true) {
      case !!matchPath(modsfactoryUrls.addonsTrendingPath(), pathname):
        dispatch(fetchAddonsTrending(params));
        break;
      case !!matchPath(modsfactoryUrls.addonsPopularPath(), pathname):
        dispatch(fetchAddonsPopular(params));
        break;
      case !!matchPath(modsfactoryUrls.addonsRecentsPath(), pathname):
        dispatch(fetchAddonsRecents(params));
        break;
      default:
        dispatch(fetchAddons(params));
    }
  }, [searchParams, pathname, typeId, currentPage, dispatch]);

  const isActive = (id: number) => {
    return typeId === id ? 'active' : '';
  }

  const renderFilterItem = (id: any) => {
    const item = TYPES[id];

    return (
      <NavBarThree.Link
        key={id}
        className={isActive(parseInt(id, 10))}
        to={`?add_type=${id}`}
      >
        {item.name}
      </NavBarThree.Link>
    )
  }

  return (
    <PageLayout>
      <PageHeader />

      <Wrapper className='v-wrapper__left'>
        <NavBarThree type='type1'>
          {TYPES_IDS.map(renderFilterItem)}
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={orderByFilter}
          />
        </Wrapper>

        <List limit={LIMIT} />
      </div>

      <Edit />
    </PageLayout>
  );
}

export default Addons;
